module.exports = __webpack_public_path__ + "media/images/game_icon/en/FT038-e7b5c614b19af0a5f949dfef52322b1d.png";